// Side-effect imports to load TypeScript type augmentations for dayjs plugins.
// Required for pnpm's strict module resolution to recognize .utc() and .tz() methods.
import 'dayjs/plugin/utc'
import 'dayjs/plugin/timezone'
import dayjs, { ConfigType, Dayjs, OptionType } from 'dayjs'
import abbrTimezone from 'dayjs-abbr-timezone'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)
dayjs.extend(advancedFormat)
dayjs.extend(utc)
dayjs.extend(tz)
dayjs.extend(abbrTimezone)

const validDateOrNull = (date?: Date | Dayjs | string | null) =>
  date !== undefined && dayjs(date).isValid() ? dayjs(date) : null

const formatDateOrNull = (
  date?: Date | Dayjs | string | null,
  format?: string,
) =>
  date !== undefined && dayjs(date).isValid()
    ? dayjs(date).format(format)
    : null

export const DATE_FORMAT = 'ddd Do MMM YYYY HH:mm'
export const DATE_FORMAT_TZONE = `${DATE_FORMAT} t`

const dateInUserTimezone = (date?: Date | Dayjs | string | null) => {
  if (!date || !dayjs(date).isValid()) return null

  const utcDate = dayjs.utc(date)
  // Only format with timezone on client side where we can get user's timezone
  if (typeof window === 'undefined') {
    return utcDate
  }

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return utcDate.tz(userTimezone)
}

const formatDateInUserTimezone = (
  date?: Date | Dayjs | string | null,
  format: string = DATE_FORMAT_TZONE,
) => {
  const tzDate = dateInUserTimezone(date)
  if (!tzDate) return null

  if (typeof window === 'undefined') {
    return tzDate.format(DATE_FORMAT)
  }

  return tzDate.format(format)
}

export {
  dateInUserTimezone,
  dayjs,
  formatDateInUserTimezone,
  formatDateOrNull,
  validDateOrNull,
}
export type { ConfigType, OptionType }
